import { uploadFileToStorage } from "@/service/api/admin-attachments";
import { AdminReleaseNotesService } from "@/service/api/admin-release-notes";

import { MediaUploader } from "../knowledge-base/media/media-upload";

export enum ReleaseNoteStatus {
  DRAFT = 1,
  PUBLISHED = 2,
}

export enum ReleaseNoteAudience {
  MANAGER = 1,
  CLIENT = 2,
}

export const RELEASE_NOTE_MEDIA_PREFIX = "release-note/";

export const RELEASE_NOTE_STATUS_OPTIONS = [
  { value: String(ReleaseNoteStatus.DRAFT), label: "Rascunho" },
  { value: String(ReleaseNoteStatus.PUBLISHED), label: "Publicado" },
];

export const RELEASE_NOTE_AUDIENCE_OPTIONS = [
  { value: String(ReleaseNoteAudience.MANAGER), label: "Gestora" },
  { value: String(ReleaseNoteAudience.CLIENT), label: "Cliente" },
];

export const releaseNoteAudienceLabel = (audiences: number[]) => {
  const labels = [...audiences]
    .sort((left, right) => left - right)
    .map((audience) => RELEASE_NOTE_AUDIENCE_OPTIONS.find((option) => option.value === String(audience))?.label)
    .filter(Boolean);

  return labels.length ? labels.join(" e ") : "—";
};

export const releaseNoteStatusLabel = (status: number) => (status === ReleaseNoteStatus.PUBLISHED ? "Publicado" : "Rascunho");

export const releaseNoteStatusVariant = (status: number) =>
  status === ReleaseNoteStatus.PUBLISHED ? ("success" as const) : ("warning" as const);

export const uploadReleaseNoteMedia: MediaUploader = async (file) => {
  const generated = await AdminReleaseNotesService.generateUploadUrl({ fileName: file.name, mimeType: file.type });
  await uploadFileToStorage(generated.uploadUrl, file);
  return AdminReleaseNotesService.confirmUpload({ id: generated.attachmentId });
};
